import { QuickDrawServiceAPI } from '../../services/QuickDrawServiceAPI';
import { AudioManager } from '../utilities/AudioManager';

export class ControlPanel extends Phaser.GameObjects.Container {
  private readonly button;
  private editBtn;
  // @ts-ignore
  private drawIdText;
  private drawId;
  private readonly screenHeight;
  private readonly screenWidth;
  private popup;
  private messagePopup;
  private messageText;
  private container;
  // @ts-ignore
  private doneBtn;
  // @ts-ignore
  private closeBtn;
  private readonly availableDraws: {};
  private readonly config;
  private popupOverlay;

  constructor(scene, screenWidth, screenHeight) {
    super(scene);
    this.config = window._po_gm.config;
    this.availableDraws = this.config.availableDraws;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.popup = document.getElementById('otw-input-popup');
    this.popup.style.visibility = 'hidden';
    this.messagePopup = document.getElementById('otw-message-popup');
    this.messagePopup.style.visibility = 'hidden';
    this.drawId = this.config.drawId;
    this.scene.add.sprite(screenWidth / 2 - 90, screenHeight - 58, 'drawingid');
    this.drawIdText = this.scene.add.text(screenWidth / 2 - 165, screenHeight - 53, this.drawId, {
      font: '32px Jost',
      color: '0x00000'
    });
    this.editBtn = this.scene.add.sprite(screenWidth / 2 - 23, screenHeight - 38, 'edit').setInteractive({ useHandCursor: true });
    this.editBtn.inputEnabled = true;
    this.editBtn.on('pointerdown', this.showInputPopup.bind(this, false));
    this.button = this.scene.add.sprite(screenWidth / 2 + 170, screenHeight - 58, 'pause').setInteractive({ useHandCursor: true });
    this.button.on('pointerdown', this.toggleButtonState.bind(this));
    this.doneBtn = this.addClickListener('otw-popup-submit', this.doneClick);
    this.closeBtn = this.addClickListener('otw-message-submit', this.closeClick);
    if (!!this.drawId && !!this.config.winningNumber) {
      if (!this.availableDraws) {
        this.availableDraws = [];
      }
      this.availableDraws[this.drawId] = { winningNumber: this.config.winningNumber, winningPrize: this.config.winningPrize };
    }
  }

  addClickListener = (elementId, method) => {
    const oldElement = document.getElementById(elementId);
    const newElement = oldElement?.cloneNode(true);
    if (newElement) {
      newElement.addEventListener('click', method);
      oldElement?.parentNode?.replaceChild(newElement, oldElement);
    }
    return newElement;
  };

  doneClick = () => {
    const regex = /^[0-9]+$/;
    const drawIdInput = document.getElementById('otw-input-draw-id') as HTMLInputElement;
    if (regex.test(drawIdInput.value)) {
      // @ts-ignore
      this.scene.resumeTimer();
      this.scene.input.enabled = true;
      this.popupOverlay?.destroy();
      this.popup.style.visibility = 'hidden';
      if (drawIdInput.value) {
        this.updateDrawId(drawIdInput.value);
      }
    } else {
      this.popupOverlay?.destroy();
      this.popup.style.visibility = 'hidden';
      this.updateDrawId(this.drawId.toString());
      this.showMessage('Invalid Draw id/Number');
    }
  };

  closeClick = () => {
    // @ts-ignore
    this.scene.resumeTimer();
    this.scene.input.enabled = true;
    this.popupOverlay?.destroy();
    this.messagePopup.style.visibility = 'hidden';
  };

  showMessage(message) {
    // @ts-ignore
    this.scene.pauseTimer();
    this.scene.input.enabled = false;
    this.messagePopup.style.visibility = 'visible';
    this.popupOverlay = this.addBackDrop();
    this.messageText = document.getElementById('otw-message-label');
    this.messageText.innerHTML = message;
  }

  updateDrawId = drawNumber => {
    if (drawNumber === this.drawId.toString()) {
      if (!!this.button && this.button.texture.key) {
        const imageName = this.button.texture.key;
        if (imageName === 'play') {
          this.button.setTexture('pause');
        }
      }
      return;
    }

    AudioManager.getInstance().pauseSoundEffect(this.scene, 'Casino_Spinning_Wheel');

    if (!this.availableDraws || !this.availableDraws[drawNumber]) {
      this.processMissingDrawId(drawNumber);
    } else {
      this.animateDraw(drawNumber);
    }
  };

  setLoading(loading) {
    window.model.setLoading(loading);
    const spinner = document.getElementById('otw-spinner');
    if (spinner) {
      if (loading) {
        // @ts-ignore
        this.scene.pauseTimer();
        spinner.style.visibility = 'visible';
      } else {
        // @ts-ignore
        this.scene.resumeTimer();
        spinner.style.visibility = 'hidden';
      }
    }
  }

  processMissingDrawId = drawNumber => {
    try {
      parseInt(drawNumber);
    } catch {
      this.showMessage('Invalid Draw id/Number');
      return;
    }

    this.setLoading(true);
    const strDrawNumber = drawNumber.toString();
    const quickDrawResult = QuickDrawServiceAPI.getQuickDrawJackpotResultsByDrawId(this.config.gameId, strDrawNumber, 0, 1);
    quickDrawResult.then(result => {
      this.setLoading(false);
      if (result.length === 0) {
        const sizeOfAvailableDraws = Object.keys(this.availableDraws).length;
        if (sizeOfAvailableDraws > 0) {
          const sortedKeys = Object.keys(this.availableDraws);
          sortedKeys.sort();
          const lastDrawId = sortedKeys[sizeOfAvailableDraws - 1];
          if (parseInt(drawNumber, 10) > parseInt(lastDrawId, 10)) {
            this.showMessage('The selected draw is not yet available');
          } else {
            this.showMessage('Invalid Draw id/Number');
          }
        } else {
          this.showMessage('Invalid Draw id/Number');
        }
      } else {
        this.availableDraws[drawNumber] = { winningNumber: result[0].winningNumber, winningPrize: result[0].winningPrize };
        this.animateDraw(drawNumber);
      }
    });
  };

  animateDraw = drawNumber => {
    this.drawId = drawNumber;
    this.updateConfig(drawNumber);

    /**
     * Make sure sound effect is stopped on new scene start
     * Prevents sound glitches on some devices, due to API attempting to resume
     */
    AudioManager.getInstance().stopSoundEffect(this.scene, 'Casino_Spinning_Wheel');

    this.scene.scene.stop('SpinScene');
    window.po_gm.start(this.config);
  };

  updateConfig = (drawNumber: number) => {
    const selectedDraw = this.availableDraws[drawNumber];
    this.config.drawId = drawNumber;
    this.config.winningNumber = selectedDraw?.winningNumber;
    this.config.winningPrize = selectedDraw?.winningPrize;
  };

  toggleButtonState = () => {
    if (!!this.button && this.button.texture.key) {
      const imageName = this.button.texture.key;
      if (imageName === 'pause') {
        this.button.setTexture('play');
        //@ts-ignore
        this.scene.pauseTimer();
      } else if (imageName === 'play') {
        this.button.setTexture('pause');
        //@ts-ignore
        this.scene.resumeTimer();
      } else if (imageName === 'replay') {
        this.scene.scene.stop('SpinScene');
        this.scene.scene.start('WelcomeScene');
      }
    }
  };

  showInputPopup = () => {
    // @ts-ignore
    this.scene.pauseTimer();
    this.scene.input.enabled = false;
    this.popup.style.visibility = 'visible';
    this.popupOverlay = this.addBackDrop();
    this.container = document.getElementById('otw-draw-container');
    this.container.style.display = 'visible';
    const drawIdInput = document.getElementById('otw-input-draw-id') as HTMLInputElement;
    drawIdInput.value = this.drawId;
  };

  addBackDrop = () => {
    const popupOverlay = this.scene.make.renderTexture({ width: this.screenWidth, height: this.screenHeight }, true);
    return popupOverlay.fill(0x000000, 0.5);
  };
}
